// extracted by mini-css-extract-plugin
export default {"CookieBanner":"CookieBanner_CookieBanner__tIe13","ButtonContainer":"CookieBanner_ButtonContainer__25dlM"};